import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { shelfViewFeedbackActions } from '../../store/store';
import { setBrands, setFlavours, setPackshots, setSelectedBrand, setSelectedFlavour, setSelectedProject, setSelectedSku, setSelectedVariant, setSelectedWeight, setSkus, setVariants, setWeights } from '../../store/ShelfView/conflictsPage';
import { StyledAutocompleteBlue } from '../components/styled_autocomplete';
import { TextField, Typography} from '@mui/material';
import { makeStyles } from '@mui/styles';
//import 'antd/dist/antd.css';

const { SubMenu } = Menu;

const NestedDropdown = (props) => {
  const [openKeys, setOpenKeys] = useState([]);
  const dispatch=useDispatch();

  const { cursorDetails } = useSelector(state => state.thumbnailStore);
  const [text,setText]=useState("");
  const {brands,variants, flavours,weights,skus,packshots,selectedBrand,selectedVariant,selectedWeight,selectedFlavour,selectedSku}=useSelector((state)=>state.conflictsPageStore);
  const {
    loading
  } = useSelector(state => state.shelfViewFeedbackStore);
 //console.log(props)
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && !['sub1', 'sub2'].includes(latestOpenKey)) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
 const handleClick=async (name,type)=>{
  //console.log("e value")
  const params = {
    ...cursorDetails,
    dataType: props.predictions.type,
    selectedType: type,
    selectedValue: name,
    currentKey: ""
  }
  // dispatch(thumbnailStoreActions.resetCursorDetails());
  dispatch(shelfViewFeedbackActions.setLoading(true))
 try{
  const response = await axios.post(
    '/thumbnail_transaction/get_node_data',
    params
  )

  if (response.status !== 200) {
    dispatch(shelfViewFeedbackActions.setLoading(false))
    return
  }

  //console.log('response nested drop down ', response.data);
  if(response.data.children.length>0 && response.data.children[0].type==="variant")
  {
    dispatch(setVariants(response.data.children))
  }
  if(response.data.children.length && response.data.children[0].type==="skus")
  {
    dispatch(setSkus(response.data.children))
  }
  dispatch(shelfViewFeedbackActions.setLoading(false))
 }
 catch(error)
 {
  console.log(error,"error")
 }
 
 }

// useEffect(()=>{
//   axios.post("/getAllData/get_all_brands").then((response)=>{
//     dispatch(setBrands(response.data))
//   }).catch((error)=>{
//     console.log(error)
//   })
// },[])

const handleChange= async(value,name)=>{
  //  console.log(value,"value",name,"name")

  if(name==="project"){
    dispatch(setSelectedProject(value));
    dispatch(setBrands([]))
    try{
      const response= await axios.post("/getAllData/get_all_brands",{project:value})
      dispatch(setBrands(response.data))
         
    }
    catch(error){
      console.log(error)
    }
  }

   if(name==="brand")
   {
    dispatch(setSelectedBrand(value))
    setText((prevText)=>prevText+value)
    dispatch(setVariants([]))
    dispatch(setWeights([]))
    dispatch(setFlavours([]))
    dispatch(setSkus([]))
    dispatch(setPackshots([]))
    axios.post("/getAllData/get_all_variants",{brand:value}).then((response)=>{
      dispatch(setVariants(response.data))
    }).catch((error)=>{
      console.log(error)
    })
   }
   if(name==="variant"){
    dispatch(setSelectedVariant(value))
    setText((prevText)=>prevText+value)
    dispatch(setWeights([]))
    dispatch(setFlavours([]))
    dispatch(setSkus([]))
    dispatch(setPackshots([]))
    axios.post("/getAllData/get_all_flavours",{variant:value}).then((response)=>{
      dispatch(setFlavours(response.data))
      if(response.data.length<1)
      {
        name="flavour";
        dispatch(setSelectedFlavour(null))
        axios.post("/getAllData/get_all_weights",{variant:value,flavour:null}).then((response)=>{
          dispatch(setWeights(response.data))
          if(response.data.length<1)
          {
            dispatch(setSelectedWeight(null))
            axios.post("/getAllData/get_all_skus",{variant:value,flavour:selectedFlavour,weight:null}).then((response)=>{
              dispatch(setSkus(response.data))
            }).catch((error)=>{
              console.log(error)
            })
          }
        }).catch((error)=>{
          console.log(error)
        })
      }
    }).catch((error)=>{
      console.log(error)
    })
   }
  
   if(name==="flavour"){
  
    dispatch(setSelectedFlavour(value))
    setText((prevText)=>prevText+value)
    dispatch(setWeights([]))
    dispatch(setSkus([]))
    dispatch(setPackshots([]))
    axios.post("/getAllData/get_all_weights",{variant:selectedVariant,flavour:value}).then((response)=>{
      dispatch(setWeights(response.data))
      if(response.data.length<1)
      {
        dispatch(setSelectedWeight(null))
    axios.post("/getAllData/get_all_skus",{variant:selectedVariant,flavour:selectedFlavour,weight:value}).then((response)=>{
      dispatch(setSkus(response.data))
    }).catch((error)=>{
      console.log(error)
    })
      }
    }).catch((error)=>{
      console.log(error)
    })
   }
   if(name==="weight")
   {
    dispatch(setSelectedWeight(value))
    setText((prevText)=>prevText+value)
    dispatch(setSkus([]))
    dispatch(setPackshots([]))
    axios.post("/getAllData/get_all_skus",{variant:selectedVariant,flavour:selectedFlavour,weight:value}).then((response)=>{
      dispatch(setSkus(response.data))
    }).catch((error)=>{
      console.log(error)
    })
   }
   if(name==="skus"){
    setText((prevText)=>prevText+value)
    dispatch(setSelectedSku(value));
    dispatch(setPackshots([]))
    axios.post("/getAllData/get_packshots",{skus:value}).then((response)=>{
      dispatch(setPackshots(response.data))
    }).catch((err)=>{
      console.log(err)
    })
   }
}
//console.log(packshots,"packshots --->")
 const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: '0.875rem',
    
  },
});
const projects=[
  "p&g", "p&g_india","null"
]
const autocomplete_classes = useAutoCompleteStyles();
  return (
    <>
    {/* <Typography style={{fontSize:"12px",marginBottom:"1rem"}}>{text}</Typography> */}
    <div style={{display:"flex",gap:"0.7rem",flexWrap:"wrap"}}>
    <StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"}}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
    // value={selectedBrand}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={projects}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a brand`}
        label="Project"
      />
    )}
    onChange={(event, value) => handleChange(value, 'project')}
  />
  {brands.length>0&&  <StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"}}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
     value={selectedBrand}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={brands}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a brand`}
        label="Brand"
      />
    )}
    onChange={(event, value) => handleChange(value, 'brand')}
  />}
   
  {variants.length>0&&<StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"  }}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
     value={selectedVariant}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={variants}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a variant`}
        label="Variant"
      />
    )}
    onChange={(event, value) => handleChange(value, 'variant')}
  />}
   {flavours.length>0&&<StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"  }}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
    value={selectedFlavour}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={flavours}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a flavour`}
        label="Flavour"
      />
    )}
    onChange={(event, value) => handleChange(value, 'flavour')}
  />}
   { weights.length>0&&<StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"  }}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
    value={selectedWeight}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={weights}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a weight`}
        label="Weight"
      />
    )}
    onChange={(event, value) => handleChange(value, 'weight')}
  />}
   {skus.length>0&&<StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"  }}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
    value={selectedSku}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={skus}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a skus`}
        label="Skus"
      />
    )}
    onChange={(event, value) => handleChange(value, 'skus')}
  />}
 
  </div>
  </>
  );
};

export default NestedDropdown;
